import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomTextFiled from "components/CustomTextField";
import AddressAutoComplete from "components/general/AddressAutoComplete";
import { FORM_VALIDATIONS } from "constants/formValidation";
import { Fragment, useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { handleSnackBar } from "slices/global";
import { useAppDispatch } from "store/appHooks";
import { placeDetails } from "utils/address.util";
import ChangePhoneNumber from "./ChangePhoneNumber";
import {
  getUserProfile,
  setSubmittingProfile,
  updateUserProfile,
} from "slices/userReducer";
import imageService from "services/image.service";
import { getCurrentTimestamp } from "utils/timestamp.util";
import { AvatarProps } from "utils/image.util";
import ChangePassword from "./ChangePassword";
import messagesService from "services/messages.service";

const ProfileForm = (props: any) => {
  const { control, setValue, getValues } = useFormContext();
  const {
    updateProfilePicture,
    pic,
    setUpdateProfilePicture,
    watchallFields,
    loadingProfile,
    submittingProfile,
    methods,
  } = props;
  const [loading, setLoading] = useState(false);
  const fileInputRef: any = useRef(null);
  const [ImageToUpload, setImageToUpload] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [dialogType, setDialogType] = useState(null);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (loadingProfile || submittingProfile) {
      setLoading(true);
    } else {
      let timeOutId: any = setTimeout(() => {
        setLoading(false);
        clearTimeout(timeOutId);
      }, 2000);
    }
  }, [loadingProfile, submittingProfile]);

  const openDialog = (type: any) => {
    setDialogType(type);
    setShowDialog(true);
  };

  useEffect(() => {
    if (!showDialog) {
      setDialogType(null);
    }
  }, [showDialog]);

  useEffect(() => {
    setValue("new_mobile_number", "");
  }, [setValue]);

  const Loader = ({ count }: any = 5) => (
    <Fragment>
      {[...Array(count)]?.map((el, ind: number) => (
        <Grid key={String(ind)} item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Skeleton
            variant="rectangular"
            sx={{ width: "100%", height: "40px" }}
          />
        </Grid>
      ))}
    </Fragment>
  );
  console.log({ watchallFields });
  const saveProfile = async (data: any) => {
    let payload = { ...data };
    let newImage = false;
    if (data.mobile_number_verified === 0) {
      methods.setError("mobile_number", {
        message: "Please verify your mobile number",
      });
      return;
    }
    dispatch(setSubmittingProfile(true));
    console.log({ ImageToUpload });
    if (ImageToUpload && typeof ImageToUpload === "object") {
      const file: any = ImageToUpload;
      const uploadResp: any = await imageService.UploadImageToStorage(
        [file],
        `user-profiles/${getCurrentTimestamp()}_${file.name.replaceAll(
          " ",
          "_"
        )}`
      );
      newImage = true;
      payload.image_url = uploadResp.preview_url;
    } else {
      payload.image_url = updateProfilePicture;
    }

    dispatch(
      updateUserProfile({
        data: payload,
        onSuccess: () => {
          if (newImage) {
            messagesService.updateUserProfileImage(payload.image_url);
          }
          messagesService.updateUserProfileName(payload.name);
          dispatch(getUserProfile());
        },
      })
    );
  };

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    setImageToUpload(file);
    setUpdateProfilePicture(URL?.createObjectURL(file));
  };

  const addressSelected = async (e: any) => {
    if (e?.place_id) {
      const details: any = await placeDetails(e?.place_id);
      if (!details.zipcode) {
        dispatch(
          handleSnackBar({
            open: true,
            message: "Invalid address, please enter valid address.",
            severity: "error",
          })
        );
        return;
      }
      setValue("addressLine1", details.addressLine1);
      setValue("addressLine2", details.addressLine2);
      setValue("city", details.city);
      setValue("state", details.state);
      setValue("zipcode", details.zipcode);
    } else {
      return;
    }
  };

  return (
    <form onSubmit={methods.handleSubmit(saveProfile)}>
      <Grid container spacing={2.5} px={1} py={0.5} pt={0}>
        <CustomDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          fullScreenOnMobile={false}
        >
          {dialogType == "changePhoneNumber" ? (
            <ChangePhoneNumber
              showDialog={showDialog}
              setShowDialog={setShowDialog}
            />
          ) : (
            <ChangePassword
              showDialog={showDialog}
              setShowDialog={setShowDialog}
            />
          )}
        </CustomDialog>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "64px",
              textAlign: "left",
              mt: -1.5,
            }}
          >
            Edit profile
          </Typography>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            mt={2}
          >
            {/* <img
              alt="user"
              src={updateProfilePicture || pic}
              style={{ width: "64px", height: "64px", borderRadius: "50%" }}
            /> */}
            <Avatar
              alt={watchallFields?.name}
              {...AvatarProps(
                [updateProfilePicture, pic],
                watchallFields?.name,
                "#eee",
                { width: "64px", height: "64px" }
              )}
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={fileInputRef}
              style={{ display: "none" }}
            />
            <Typography
              onClick={() => fileInputRef?.current?.click()}
              sx={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "left",
                color: "#307AFF",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Change Profile Image
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container spacing={2.5}>
            {loading && <Loader count={3} />}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="name"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="name"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                    />
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="email"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="email"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      inputProps={{ disabled: true }}
                    />
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="mobile_number"
                  defaultValue=""
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED_MOBILE,
                    ...FORM_VALIDATIONS.maxLengthValidation(10),
                    ...FORM_VALIDATIONS.minLengthValidation(10),
                  }}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      inputValue={value}
                      label="mobile number"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      dropDownOptions={[{ id: "+1", name: "+1" }]}
                      showEndDropDown={true}
                      dropDownValue="+1"
                      onDropDownChange={() => {}}
                      dropDownPosition="left"
                      inputProps={{
                        disabled: true,
                        style: { WebkitTextFillColor: "red" },
                      }}
                      showVerifiedIconAtEnd={
                        watchallFields?.mobile_number_verified && value
                          ? true
                          : false
                      }
                    />
                  )}
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              display="flex"
              alignItems="center"
            >
              <Typography
                onClick={() => !loading && openDialog("changePhoneNumber")}
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  textAlign: "left",
                  color: "#307AFF",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Change Phone Number
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "19.36px",
                  textAlign: "left",
                }}
              >
                Address
              </Typography>
            </Grid>
            {loading && <Loader count={5} />}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="addressLine1"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <AddressAutoComplete
                        onSelect={(e: any) => {
                          addressSelected(e);
                          onChange(e);
                        }}
                        omitAddressFilter={false}
                        CustomInput={(p: any) => {
                          return (
                            <CustomTextFiled
                              inputRef={p.InputProps.ref}
                              label="Address Line 1"
                              paramProps={p}
                            />
                          );
                        }}
                        defaultValue={{
                          structured_formatting: {
                            main_text: value,
                            secondary_text: "",
                          },
                          description: "",
                        }}
                      />
                      {!!error && (
                        <Typography color="error" variant="caption">
                          {"Please add address." ?? ""}
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="addressLine2"
                  defaultValue=""
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="Address Line 2"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                    />
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="city"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="city"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                    />
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="state"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="state"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                    />
                  )}
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name="zipcode"
                  defaultValue=""
                  rules={FORM_VALIDATIONS.REQUIRED}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="zipcode"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                    />
                  )}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "19.36px",
                  textAlign: "left",
                }}
              >
                About
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {loading ? (
                <Skeleton variant="rectangular" width="100%" height="130px" />
              ) : (
                <Controller
                  control={control}
                  name="summary"
                  defaultValue=""
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED,
                    ...FORM_VALIDATIONS.maxLengthValidation(500),
                    ...FORM_VALIDATIONS.minLengthValidation(50),
                  }}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="summary"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      multiline={true}
                      rows={3}
                      inputHeight="100%"
                    />
                  )}
                />
              )}
            </Grid>
            {props.isPasswordLogin && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "19.36px",
                    textAlign: "left",
                  }}
                >
                  Want to Change Password?
                </Typography>

                <Typography
                  onClick={() => !loading && openDialog("changePassword")}
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 600,
                    lineHeight: "18.15px",
                    textAlign: "left",
                    color: "#307AFF",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  Change Password
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box
                pt={2}
                pb={5}
                display="flex"
                justifyContent={isMobileView ? "center" : "end"}
              >
                <Button
                  variant="contained"
                  size="large"
                  type="submit"
                  disabled={loading}
                  endIcon={loading ? <CircularProgress size={15} /> : null}
                  {...(isMobileView && { fullWidth: true })}
                >
                  Update
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default ProfileForm;
